<template>
  <v-container fluid grid-list-xl>
    <v-layout text-xs-center center row wrap>
      <v-flex xs12 sm12>
        <h1>Panel de Inicio</h1>
      </v-flex>
    </v-layout>

    <v-layout class="hidden-sm-and-up" text-xs-center center row wrap>
      <v-flex xs12>
        <v-btn v-if="isAdmin" :to="{ name: 'eventoLista' }">Eventos</v-btn>
        <v-btn v-if="isOrganizador" :to="{ name: 'eventoListaOrganizador' }"
          >Mis Eventos</v-btn
        >
        <v-btn v-if="isAdmin" :to="{ name: 'organizadoresLista' }"
          >Organizadores</v-btn
        >
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm12 md6>
        <h3 class="headline my-2 text-xs-center">Próximos eventos</h3>
        <v-card>
          <table
            class="v-datatable v-table v-datatable--select-all theme--light"
          >
            <thead>
              <tr>
                <th>Evento</th>
                <th class="hidden-sm-and-down">Ciudad</th>
                <th>Fecha</th>
                <th>Inscriptos</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="e in eventos" :key="e && e.id ? e.id : Math.random()">
                <td class="text-xs-center">
                  {{ e && e.nombre ? e.nombre : "Sin nombre" }}
                </td>
                <td class="text-xs-center hidden-sm-and-down">
                  {{ e && e.ciudad ? e.ciudad : "Sin ciudad" }}
                </td>
                <td class="text-xs-center">
                  {{ formatEventDate(e.fecha_hora) }}
                </td>
                <td class="text-xs-center">
                  <v-btn
                    v-if="e && e.id"
                    outline
                    color="primary"
                    small
                    type="secondary"
                    :to="{ name: 'evento', params: { id: e.id } }"
                  >
                    {{
                      e && e.total_personas_inscriptos
                        ? e.total_personas_inscriptos
                        : 0
                    }}
                    Inscriptos
                  </v-btn>
                  <span v-else>Sin datos</span>
                </td>
              </tr>
            </tbody>
          </table>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md6>
        <h3 class="headline my-2 text-xs-center">Últimos inscriptos</h3>
        <v-card>
          <table
            class="v-datatable v-table v-datatable--select-all theme--light"
          >
            <thead>
              <tr>
                <th>Nombre/Apellido</th>
                <th>Fecha Inscr</th>
                <th>Evento</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="i in inscripciones"
                :key="i && i.id ? i.id : Math.random()"
              >
                <td class="text-xs-center">
                  <span v-if="i && i.personas && i.personas[0]">
                    {{ i.personas[0].nombre || "Sin nombre" }},
                    {{ i.personas[0].apellido || "Sin apellido" }}
                  </span>
                  <span v-else>Sin datos del participante</span>
                </td>
                <td class="text-xs-center">
                  {{ formatInscriptionDate(i.created_at) }}
                </td>
                <td class="text-xs-center">
                  {{
                    i &&
                    i.modalidad &&
                    i.modalidad.evento &&
                    i.modalidad.evento.nombre
                      ? i.modalidad.evento.nombre
                      : "Sin evento"
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </v-card>
      </v-flex>

      <v-flex xs12 sm12 md6>
        <h3 class="headline my-2 text-xs-center">Últimos pagos realizados</h3>
        <v-card>
          <table
            class="v-datatable v-table v-datatable--select-all theme--light"
          >
            <thead>
              <tr>
                <th>Participante</th>
                <th>Estado</th>
                <th class="hidden-sm-and-down">Fecha Subida</th>
                <th>Evento</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="pago in pagos"
                :key="pago && pago.id ? pago.id : Math.random()"
              >
                <td class="text-xs-center">
                  <span v-if="pago && pago.personas && pago.personas[0]">
                    {{ pago.personas[0].nombre || "Sin nombre" }},
                    {{ pago.personas[0].apellido || "Sin apellido" }}
                  </span>
                  <span v-else>Sin datos del participante</span>
                </td>
                <td class="text-xs-center">
                  <v-chip
                    :color="
                      getEstadoColor(pago && pago.state ? pago.state : null)
                    "
                    text-color="white"
                    small
                  >
                    {{ getEstadoLabel(pago && pago.state ? pago.state : null) }}
                  </v-chip>
                </td>
                <td class="text-xs-center hidden-sm-and-down">
                  {{ formatPaymentDate(pago.payment_receipt_uploaded_at) }}
                </td>
                <td class="text-xs-center">
                  <div v-if="pago && pago.modalidad && pago.modalidad.evento">
                    <div style="margin-bottom: 5px">
                      {{ pago.modalidad.evento.nombre }}
                    </div>
                  </div>
                </td>
                <td class="text-xs-center">
                    <v-btn
                      @click.stop="abrirMarcarPagada(pago)" 
                      color="green"
                      small
                      outlined
                    >
                      <v-icon left small>attach_money</v-icon>
                      Marcar Pagada
                    </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </v-card>
      </v-flex>
    </v-layout>

    <MarcarPagadaDialog 
      ref="dialogMarcarPagada" 
      :inscripcion="inscripcionEditar"
      @refrescarDatos="() => { this.getDataFromApi() }"
    />
  </v-container>
</template>

<script>
import Vuex from "vuex";
import api from "../../api/inscripcion";
import moment from "moment";
import MarcarPagadaDialog from "../../components/inscripcion/inscripcion-pagada/MarcarPagadaDialog.vue";

export default {
  components: {
    MarcarPagadaDialog,
  },
  data() {
    return {
      inscripciones: [],
      eventos: [],
      pagos: [],
      contenido: "",
      total: "-",
      inscripcionEditar: {},
    };
  },
  computed: {
    ...Vuex.mapGetters("auth", [
      "isLoggedIn",
      "isAdmin",
      "isOrganizador",
      "nombreUsuario",
    ]),
    ...Vuex.mapState("auth", ["user.name"]),
  },
  mounted() {
    this.getDataFromApi();
  },
  methods: {
    formatPaymentDate(date) {
      if (!date) return "Sin fecha";
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    formatEventDate(date) {
      if (!date) return "Sin fecha";
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    formatInscriptionDate(date) {
      if (!date) return "Sin fecha";
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    getEstadoColor(estado) {
      const colores = {
        pago_realizado: "success",
        pago_en_revision: "warning",
        pago_rechazado: "error",
        pago_pendiente: "info",
      };
      return colores[estado] || "grey";
    },
    getEstadoLabel(estado) {
      const labels = {
        pago_realizado: "Aprobado",
        pago_en_revision: "En Revisión",
        pago_rechazado: "Rechazado",
        pago_pendiente: "Pendiente",
      };
      return labels[estado] || estado || "Sin estado";
    },

    abrirMarcarPagada(inscripcion) {
      this.inscripcionEditar = JSON.parse(JSON.stringify(inscripcion));
      this.$refs.dialogMarcarPagada.abrirDialog();
    },

    getDataFromApi() {
      this.loading = true;
      if (this.isAdmin) {
        this.getDataAdmin();
      } else {
        this.getDataOrganizador();
      }
    },

    getDataOrganizador() {
      api
        .getMisUltimasInscripciones()
        .then((res) => {
          this.inscripciones = res || [];
        })
        .finally(() => {
          this.loading = false;
        });

      api
        .getMisProximosEventos()
        .then((res) => {
          this.eventos = res && res.data ? res.data : [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getDataAdmin() {
      api
        .getUltimasInscripciones()
        .then((res) => {
          this.inscripciones = res || [];
        })
        .finally(() => {
          this.loading = false;
        });

      api
        .getProximosEventos()
        .then((res) => {
          this.eventos = res && res.data ? res.data : [];
        })
        .finally(() => {
          this.loading = false;
        });

      api
        .getPayments({ limit: 5 })
        .then((res) => {
          this.pagos = res || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>